import React, { FC, useCallback } from 'react';
import { useAuthModal } from '../../../hooks/useAuthModal';
import { ModalOverlay } from '../../Modal';
import { Authentication } from '../Authentication';

export const AuthenticationModal: FC = () => {
  const { show, closeAuthModal, handleAuthSuccess } = useAuthModal();

  const handleAuth = useCallback(() => {
    handleAuthSuccess();
    closeAuthModal();
  }, [closeAuthModal, handleAuthSuccess]);

  return (
    <ModalOverlay data-testid="authentication-modal" onClose={closeAuthModal} show={show}>
      <Authentication onAuth={handleAuth} modal />
    </ModalOverlay>
  );
};
